export default __webpack_public_path__ + "static/media/5_portugal-image.2cd585fe.jpg";